'use strict'

import indexCtrl from './index.controller.js'
import indexTmpl from './index.template.html'

export default {
		template: indexTmpl,
		controller: indexCtrl,
		controllerAs: 'vm'
	}


// WEBPACK FOOTER //
// ./src/app/pages/index/index.page.js